import React, { type FC } from 'react';

import type { InputOption } from '../forms/Inputs';

interface RadioInputProps {
  option: InputOption;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  className?: string;
  labelClassName?: string;
  name: string;
  checked?: boolean;
}

const RadioInput: FC<RadioInputProps> = ({
  option,
  onChange,
  onClick,
  className = '',
  labelClassName = '',
  name,
  checked,
}) => {
  return (
    <fieldset
      className={`flex cursor-pointer items-center text-leland-gray-dark ${labelClassName}`}
    >
      <input
        className={`form-radio mr-2 rounded ${className}`}
        type="radio"
        name={name}
        value={option.value}
        onChange={onChange}
        onClick={onClick}
        checked={checked}
        id={`radio-${option.value}`}
      />
      <label
        htmlFor={`radio-${option.value}`}
        className="flex w-full cursor-pointer flex-col items-start justify-center"
      >
        <div className="w-full text-leland-gray-dark">{option.label}</div>
        <p className="text-leland-gray-light">{option.subLabel}</p>
      </label>
    </fieldset>
  );
};

export default RadioInput;
